"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));

var _AccordionDetails = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));

var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      margin: '0 !important',
      width: '33.3%',
      paddingLeft: theme.spacing(6.5),
      paddingRight: theme.spacing(6.5),
      boxShadow: 'none',
      background: theme.palette.background.default,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      '&:not(:last-child)': (0, _defineProperty2.default)({
        borderRight: '1px solid rgba(0,0,0,.2)'
      }, theme.breakpoints.down('sm'), {
        borderRight: 'none'
      }),
      '&:last-child': (0, _defineProperty2.default)({
        borderRight: '1px solid rgba(0,0,0,.2)'
      }, theme.breakpoints.down('sm'), {
        borderRight: 'none'
      }),
      '&:first-child': (0, _defineProperty2.default)({
        borderLeft: '1px solid rgba(0,0,0,.2)'
      }, theme.breakpoints.down('sm'), {
        borderLeft: 'none'
      }),
      '& ul': {
        listStyleType: 'none',
        padding: 0,
        margin: 0
      },
      '& li': {
        paddingLeft: theme.spacing(4),
        marginTop: theme.spacing(1),
        position: 'relative' // '&:after': {
        //   content: '""',
        //   width: 10,
        //   height: 10,
        //   backgroundImage: 'url("https://image.flaticon.com/icons/png/512/120/120893.png")',
        //   backgroundSize: 'contain',
        //   backgroundRepeat: 'no-repeat',
        //   position: 'absolute',
        //   left: 0,
        //   top: 5,
        // },

      }
    }, theme.breakpoints.down('sm'), {
      width: '100%',
      padding: 0
    }),
    link: {
      color: theme.palette.common.black,
      fontSize: 22,
      textTransform: theme.text.textTransformUppercase
    },
    summary: {}
  };
}, {
  name: 'SxComFooterMenuColumn'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null);

function FooterMenuColumn(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      href = _ref.href,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "href", "title"]);
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _styles.useTheme)();
  var isWide = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  return /*#__PURE__*/_react.default.createElement(_Accordion.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    expanded: !isWide ? expanded : true,
    onChange: function onChange() {
      return !isWide ? setExpanded(function (state) {
        return !state;
      }) : null;
    }
  }), /*#__PURE__*/_react.default.createElement(_AccordionSummary.default, {
    className: classes.summary,
    style: {
      cursor: 'default'
    },
    expandIcon: !isWide && _ref2
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.link,
    variant: "body1"
  }, title)), /*#__PURE__*/_react.default.createElement(_AccordionDetails.default, null, children));
}

process.env.NODE_ENV !== "production" ? FooterMenuColumn.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    column: _propTypes.default.string,
    link: _propTypes.default.string,
    root: _propTypes.default.string,
    summary: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  href: _propTypes.default.string,
  title: _propTypes.default.string
} : void 0;
FooterMenuColumn.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  href: '/',
  title: undefined
};
var _default = FooterMenuColumn;
exports.default = _default;